var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPodcastIcon = function SvgPodcastIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 72 72",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1F2E53",
    d: "M33.6 58.8h4.8V66h-4.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F2E53",
    d: "M45.6 44.4a2.4 2.4 0 0 1 4.8 0v1.2a14.4 14.4 0 1 1-28.8 0v-1.2a2.4 2.4 0 0 1 4.8 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8EADFD",
    d: "M70.79 35.2a34.7 34.7 0 0 1-11.549 26.7 2.416 2.416 0 0 1-4.041-1.78 2.43 2.43 0 0 1 .826-1.808 30 30 0 1 0-40.053 0 2.44 2.44 0 0 1 .827 1.808 2.407 2.407 0 0 1-3.978 1.836 34.8 34.8 0 1 1 57.968-26.76z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#8EADFD",
    d: "M55.327 42.539a20.401 20.401 0 1 0-38.654-.001c.083.24.126.492.127.746a2.4 2.4 0 0 1-4.665.804 25.1 25.1 0 0 1-1.32-8.903A25.2 25.2 0 0 1 61.2 36a25 25 0 0 1-1.33 8.075 2.4 2.4 0 0 1-4.67-.79c0-.254.044-.506.127-.746"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#284797",
    d: "M45.6 31.2a9.6 9.6 0 0 0-19.2 0v14.4a9.6 9.6 0 0 0 19.2 0zM30 64.8h12a2.4 2.4 0 0 1 2.4 2.4v2.4a1.2 1.2 0 0 1-1.2 1.2H28.8a1.2 1.2 0 0 1-1.2-1.2v-2.4a2.4 2.4 0 0 1 2.4-2.4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9E4FE",
    d: "M32.4 32.4a1.2 1.2 0 0 1-1.2 1.2h-4.8v-2.4h4.8a1.2 1.2 0 0 1 1.2 1.2M32.4 38.4a1.2 1.2 0 0 1-1.2 1.2h-4.8v-2.4h4.8a1.2 1.2 0 0 1 1.2 1.2M32.4 44.4a1.2 1.2 0 0 1-1.2 1.2h-4.8v-2.4h4.8a1.2 1.2 0 0 1 1.2 1.2M45.6 31.2v2.4h-4.8a1.2 1.2 0 1 1 0-2.4zM45.6 37.2v2.4h-4.8a1.2 1.2 0 1 1 0-2.4zM45.6 43.2v2.4h-4.8a1.2 1.2 0 1 1 0-2.4z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPodcastIcon);
export default ForwardRef;